export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8237.b4220833.jpg";